// test1687
(1687 && 0);
